import React, {ReactNode} from 'react';
import Translate from '../Translate/Translate';
import classnames from '../../helpers/classnames';
import Spinner from '../Spinner/Spinner';

export default class LoaderOnOverlay extends React.Component<{
    children: ReactNode,
    loading?: boolean,
    forceDisplay?: boolean,
    innerRef?: React.Ref<HTMLDivElement>,
    contentContainerRef?: React.Ref<HTMLDivElement>,
}> {
    protected shouldBeDisplayed(): boolean {
        return this.props.loading === true || this.props.forceDisplay === true;
    }

    render() {
        const shouldDisplay = this.shouldBeDisplayed();

        return <div className={classnames({'loader-on-overlay': shouldDisplay})}>
            <div
                    className={classnames({'loader-on-overlay__content': shouldDisplay})}
                    ref={this.props.contentContainerRef}
            >
                {this.props.children}
            </div>

            <div className={classnames('loader-on-overlay__backdrop', {
                'd-none': !shouldDisplay
            })} ref={this.props.innerRef}>
                {this.props.loading === true ? (
                        <>
                            <Spinner type="chase" color="primary"/>
                            <Translate
                                    message="LoaderOnOverlay.loading"
                                    tag="div"
                                    className="loader-on-overlay__loader ms-2"
                            />
                        </>
                ) : null}
            </div>
        </div>;
    }
}
